import ScreenNavigator from "../../../../../lib/html5-software-library/src/ranj/ui/ScreenNavigator";
import AbstractCommand from "../../../core/application/AbstractCommand";
import LaptopSetupNavigatorEvent from "../model/LaptopSetupNavigatorEvent";

export default class LaptopSetupNavigatorCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {ScreenNavigator} laptopScreenNavigator 
     */
    constructor(dispatcher, laptopScreenNavigator) {
        super(dispatcher);

        this._laptopScreenNavigator = laptopScreenNavigator;
    }

    execute(evt) {
        /** @type {LaptopSetupNavigatorEvent} */
        const data = evt.params.data;

        this._laptopScreenNavigator.setScreenDimensions(data.size.x, data.size.y);
        this._laptopScreenNavigator.setContextView(data.contextView);
    }
}